export default {
    name: 'router-view-custom',
    props: {
        alive: {
            type: Boolean,
            default: false
        }
    },
    render() {
        const {
            $route: { matched }
        } = this;

        const alive = matched.some(({ meta }) => meta.alive === true);

        const $view = <router-view />;
        const $keep = <keep-alive>{$view}</keep-alive>;

        if (!this.alive && !alive) return $view;
        return $keep;
    }
};
